export enum AuditLogText {
  CREATE = 'Create',
  UPDATE = 'Update',
  IMPORT = 'Import',
  EXPORT = 'Export',
  DELETE = 'Delete',
  UNDEPLOY = 'Undeploy',
  DEPLOY = 'Deploy',
  IMPORT_LIST_DATA = 'Import Data',
  PAGE_VIEW = 'Page View',
  COMPONENT_USER_WORK = 'Component Work',
  COMPONENT_USER_THROW = 'Component User Throw',
  CASE_CLOSE_BULK = 'Case Close Bulk',
  CASE_ASSIGNEE = 'Case Assignee',
  REDEPLOY = 'Redeploy',
  VARIABLE_DELETE = 'Variable Delete',
  TEST = 'Test',
  LOGIN = 'Login',
  CASE_CLOSE = 'Case Close',
  CASE_GO = 'Case Go',
  CASE_COMMENT = 'Case Comment',
  CASE_ATTACHMENT = 'Case Attachment',
  EVENT_CREATE = 'Event Create',
  EVENT_UPDATE = 'Event Update',
  EVENT_DELETE = 'Event Delete',
  EVENT_DEPLOY = 'Event Deploy',
  EVENT_REDEPLOY = 'Event Redeploy',
  EVENT_UNDEPLOY = 'Event Undeploy',
  EVENT_VARIABLE_DELETE = 'Event variable Delete',
  ENRICHMENT_CREATE = 'Enrichment Create',
  ENRICHMENT_UPDATE = 'Enrichment Update',
  ENRICHMENT_DELETE = 'Enrichment Delete',
  ENRICHMENT_DEPLOY = 'Enrichment Deploy',
  ENRICHMENT_REDEPLOY = 'Enrichment Redeploy',
  ENRICHMENT_UNDEPLOY = 'Enrichment Undeploy',
  LIST_CREATE = 'List  Create',
  LIST_UPDATE = 'List Update',
  LIST_DELETE = 'List Delete',
  LIST_DEPLOY = 'List Deploy',
  LIST_REDEPLOY = 'List Redeploy',
  LIST_UNDEPLOY = 'List Undeploy',
  LIST_VARIABLE_DELETE = 'List_VARIABLE Delete',
  RULE_CREATE = 'Rule Create',
  RULE_UPDATE = 'Rule Update',
  RULE_DELETE = 'Rule Delete',
  RULE_DEPLOY = 'Rule Deploy',
  RULE_UNDEPLOY = 'Rule Undeploy',
  STRUCTURE_CREATE = 'Structure Create',
  STRUCTURE_UPDATE = 'Structure Update',
  STRUCTURE_DELETE = 'Structure Delete',
  STRUCTURE_VARIABLE_DELETE = 'Structure_VARIABLE Delete',
  CONNECTION_CREATE = 'Connection Create',
  CONNECTION_DELETE = 'Connection Delete',
  CONNECTION_DEPLOY = 'Connection Deploy',
  CONNECTION_UNDEPLOY = 'Connection Undeploy',
  CONNECTION_TEST_MSSQL = 'Connection_TEST_MSSQL',
  USER_CREATE = 'User Create',
  USER_UPDATE = 'User Update',
  USER_DELETE = 'User Delete',
  ROLE_CREATE = 'Role Create',
  ROLE_UPDATE = 'Role Update',
  ROLE_DELETE = 'Role Delete',
  GROUP_CREATE = 'Group Create',
  GROUP_UPDATE = 'Group Update',
  GROUP_DELETE = 'Group Delete',
  CASE_BULK_ACTION = 'CASE_BULK_ACTION',
  CASE_UNASSIGMENT = 'CASE_UNASSIGMENT',
  CASE_HOLD = 'CASE_HOLD',
  CASE_COMMENT_EDIT = 'CASE_COMMENT_EDIT',
  CASE_COMMENT_DOMAIN = 'CASE_COMMENT_DOMAIN',
  CASE_COMMENT_EDIT_DOMAIN = 'CASE_COMMENT_EDIT_DOMAIN',
  CASE_ATTACHMENT_DOMAIN = 'CASE_ATTACHMENT_DOMAIN',
  CASE_TAGGED_FIELD = 'CASE_TAGGED_FIELD',
  ENTITY_UPDATE = 'ENTITY_UPDATE',
  ENTITY_COMMENT = 'ENTITY_COMMENT',
  ENTITY_COMMENT_EDIT = 'ENTITY_COMMENT',
  COMPONENT_WORK = 'COMPONENT_WORK',
  CASE_RUN_ACTION = 'CASE_RUN_ACTION',
  KYC_RUN_ACTION = 'KYC_RUN_ACTION',
  ADD_ITEM_TO_CATEGORY = 'ADD_ITEM_TO_CATEGORY',
  ADD_CATEGORY_TO_CATEGORY = 'ADD_CATEGORY_TO_CATEGORY',
  CATEGORY_UPDATE_NAME = 'CATEGORY_UPDATE_NAME',
  REMOVE_ITEM_FROM_CATEGORY = 'REMOVE_ITEM_FROM_CATEGORY',
  MAKER_REQUEST = 'Maker request',
  MAKER_REQUEST_APPROVE = 'Checker request approve',
  CHECKER_APPROVE = 'Checker request approve',
  MAKER_REQUEST_REJECT = 'Checker request reject',
  ADD_LIST_DATA = 'Create Item',
  REMOVE_LIST_DATA = 'Remove Item',
  UPDATE_LIST_DATA = 'Update Item',
  WATCHLIST_SEARCH_ONE = 'Watchlist search one',
  WATCHLIST_SEARCH_MANY = 'Watchlist search many',
  ALERT_COMMENT = 'Alert comment',
  TRANSACTION_DATA_EXPORT = 'Transaction data export',
  CASE_DATA_EXPORT = 'Case data export',
  CASE_BATCH_CLOSE = 'Case batch close',
  AUDIT_LOG_EXPORT = 'Audit log export',
  ALERT_EXPORT = 'Alert export',
  SEND_TRANSACTION = 'Send transaction',
  LIST_DATA_EXPORT = 'List data export',
  CRA_RESULT_EXPORT = 'CRA assessment export',
  MATCH_MANY_LOG_EXPORT = 'Watchlist history export',
  MATCH_MANY_LOG_RESULT_EXPORT = 'Watchlist history result export',
  CASE_VARIABLE_PANEL_EXPORT = 'Transaction panel export',
  CHART_EXPORT = 'Chart export',
  GRAPH_EXPORT = 'Graph export',
  ADMIN_AUDITS_EXPORT = 'Admin audits export',
  LOGIN_AUDITS_EXPORT = 'Login audits export',
  CASE_LOG_EXPORT = 'Case log export',
  ACH_DATA_EXPORT = 'ACH data export',
}
